import { render, staticRenderFns } from "./PcrTable.vue?vue&type=template&id=cc0a477a&"
import script from "./PcrTable.vue?vue&type=script&lang=js&"
export * from "./PcrTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports